import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { postAddPortalUpdate } from "../../../actions/AdminActions";
import AddPortalUpdate from "../components/AddPortalUpdate";
import { PortalUpdateData } from "../../../models/User";

const mapStateToProps = ({
  loggedInUserState,
  getPortalUpdateState,
}: ApplicationState) => ({
  loggedInUser: loggedInUserState.response,
  portalUpdateState: getPortalUpdateState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    postAddPortalUpdate: (payload: PortalUpdateData) => {
      dispatch(postAddPortalUpdate(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPortalUpdate);
